document.addEventListener('DOMContentLoaded', function() {
    const poster = document.querySelector('.vimeo-poster');
    const iframe = document.getElementById('vimeoPlayer');

    if (!iframe) {
        console.error('Vimeo iframe hittades inte.');
        return;
    }

    // Kolla om Vimeo Player.js finns, annars ladda in det
    if (typeof Vimeo === 'undefined') {
        let script = document.createElement('script');
        script.src = 'https://player.vimeo.com/api/player.js';
        script.onload = initVimeoPlayer;
        document.body.appendChild(script);
    } else {
        initVimeoPlayer();
    }

    function initVimeoPlayer() {
        const player = new Vimeo.Player(iframe);

        player.on('play', function() {
            poster.classList.add('opacity-0');
            iframe.classList.add('opacity-100');
        });

        player.on('error', function(error) {
            console.error('Vimeo error:', error);
        });
    }
});
//# sourceMappingURL=vimeo-poster.js.map
